import FaviconDark from '../code-only/assets/logo/Favicon-Dark.svg'
import FaviconLight from '../code-only/assets/logo/Favicon-Light.svg'
import SubmarkDark from '../code-only/assets/logo/Logo-Submark-Dark.webp'
import SubmarkWhite from '../code-only/assets/logo/Logo-Submark-White.webp'
import WordmarkDark from '../code-only/assets/logo/Logo-Wordmark-Dark.webp'
import WordmarkWhite from '../code-only/assets/logo/Logo-Wordmark-White.webp'

export const logo = {
  SubmarkDark,
  SubmarkWhite,
  WordmarkDark,
  WordmarkWhite,
  FaviconLight,
  FaviconDark,
} as const
